import { useState } from 'react'

import { useSelector } from 'react-redux'

import { Box } from '@chakra-ui/react'

import {
  BadgeCounter,
  FilterIcon,
  IconButton,
  TABLE_MAX_WIDTH,
  TableToolbar,
} from '@hivewatch/dark'
import type { ColorScheme } from '@hivewatch/dark'

import { sopFilterCountSelector } from '@/redux/ui/uiSlice'

import { DarkSOPsFilterDrawer } from '../../sops-filter-drawer'

interface SOPsTableToolbarIProps {
  colorScheme: ColorScheme
  filter: string
  setFilter: (value: string) => void
}

export const SOPsTableToolbar = ({
  colorScheme,
  filter,
  setFilter,
}: SOPsTableToolbarIProps) => {
  const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false)
  const filterCount = useSelector(sopFilterCountSelector)

  return (
    <>
      <TableToolbar
        actions={
          <Box
            alignItems='center'
            cursor='pointer'
            display='flex'
            gap='8px'
            onClick={() => setIsFilterDrawerOpen(true)}
          >
            {filterCount > 0 && (
              <BadgeCounter
                colorScheme={colorScheme}
                count={filterCount}
                variant='button'
              />
            )}
            <IconButton
              aria-label='Filter'
              colorScheme={colorScheme}
              dimension={36}
              icon={<FilterIcon colorScheme={colorScheme} />}
            />
          </Box>
        }
        colorScheme={colorScheme}
        maxWidth={TABLE_MAX_WIDTH}
        onChange={setFilter}
        placeholder='Search SOPs'
        value={filter ?? ''}
      />
      <DarkSOPsFilterDrawer
        colorScheme={colorScheme}
        isOpen={isFilterDrawerOpen}
        onClose={() => setIsFilterDrawerOpen(false)}
      />
    </>
  )
}
